import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconDeviceMobile, IconInfoCircle } from '@tabler/icons-react';
import AuthLayout from './AuthLayout';
import useAuthRedirect from './useAuthRedirect';
import { Button, Checkbox, PasswordField, PhoneField } from '../../components/common';
import authApi from '../../api/auth/authApi';
import { USE_MOCK } from '../../api/client';
import { PATHS } from '../../routes/paths';
import { DEFAULT_COUNTRY_CODE, DEMO_LOGIN } from '../../utils/constants';
import * as v from '../../utils/validators';

export default function LoginPage() {
  const location = useLocation();
  const { complete } = useAuthRedirect();
  const [form, setForm] = useState(USE_MOCK
    ? { countryCode: DEMO_LOGIN.countryCode, phone: DEMO_LOGIN.phone, password: DEMO_LOGIN.password, remember: true }
    : { countryCode: DEFAULT_COUNTRY_CODE, phone: '', password: '', remember: true });
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState('');
  const [loading, setLoading] = useState(false);
  const set = (k) => (val) => setForm((f) => ({ ...f, [k]: val }));

  const submit = async (e) => {
    e.preventDefault();
    const errs = v.validate(form, { phone: v.phone, password: (p) => (p ? '' : 'Password is required') });
    setErrors(errs);
    setFormError('');
    if (Object.keys(errs).length) return;
    setLoading(true);
    try {
      const session = await authApi.login(form);
      complete(session, form.remember);
    } catch (err) {
      setFormError(err.message);
      setLoading(false);
    }
  };

  const linkState = { state: location.state };

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Log in to manage your appointments."
      footer={(
        <p>
          {'New patient? '}
          <Link to={PATHS.register} {...linkState} className="link">Create an account</Link>
        </p>
      )}
    >
      <form onSubmit={submit} noValidate>
        {formError && <div className="alert u-mb-4"><IconInfoCircle size={18} />{formError}</div>}
        <PhoneField
          countryCode={form.countryCode}
          onCountryCodeChange={set('countryCode')}
          value={form.phone}
          onChange={set('phone')}
          error={errors.phone}
        />
        <PasswordField
          label="Password"
          aside={<Link to={PATHS.forgotPassword} className="link u-text-sm">Forgot password?</Link>}
          placeholder="Enter your password"
          autoComplete="current-password"
          value={form.password}
          onChange={(e) => set('password')(e.target.value)}
          error={errors.password}
        />
        <Checkbox
          className="u-mt-6"
          label="Keep me logged in on this device"
          checked={form.remember}
          onChange={(e) => set('remember')(e.target.checked)}
        />
        <Button type="submit" block className="u-mt-6" loading={loading}>Log in</Button>
        <div className="or-divider">or</div>
        <Button variant="outline" block to={PATHS.loginSms} {...linkState}>
          <IconDeviceMobile size={20} />
          Log in with SMS code
        </Button>
        {USE_MOCK && <p className="field__hint u-text-center u-mt-4">Demo account: +60 12 345 6789 · password123</p>}
      </form>
    </AuthLayout>
  );
}
